import { NameValuePair } from "../../../models/interfaces";
import classes from "./combo-box.module.css";

export interface ComboBoxProps
  extends React.ComponentPropsWithoutRef<"select"> {
  id: string;
  text: string;
  prompt: string;
  onSelectionChange?: (id: any) => void;
  items?: NameValuePair[] | undefined;
  useFloatingLabels?: boolean;
  selectedItem?: string;
}

function ComboBox(props: ComboBoxProps) {
  const itemCount: number = props.items?.length as number;

  const getId = (itemId: any) => {
    if (itemId === undefined) {
      if (typeof itemId === "string") return "";
      return 0;
    }
    return "";
  };

  const keyId = getId(props.items?.[0].id);

  return (
    <div className="form-group">
      <label htmlFor={props.id} className="control-label">
        {props.text}
      </label>
      <select
        className="form-control"
        name={props.id}
        id={props.id}
        onChange={props.onChange}
        value={props.value}
      >
        <option key={keyId} value={keyId}>
          {props.prompt}
        </option>
        {itemCount >= 1 &&
          props.items?.map((d) => (
            <option key={`${keyId}_${d.id}`} value={d.id}>
              {d.name}
            </option>
          ))}
      </select>
    </div>
  );
}

export default ComboBox;
